
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'

@Component({})
export default class extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'DashboardBlock'

  @Prop({ type: String, default: '' }) title: string
  @Prop({ type: String, default: '' }) desc: string
  @Prop({ type: String, default: '' }) label: string
  @Prop({ type: Number, default: 0 }) percent: number
  @Prop({ type: Number, default: 0 }) value: number
  @Prop({ type: String, default: '#3699FF' }) color: string

  /**
   * 进度条背景颜色
   */
  get progressBgColor() {
    if (!this.color || this.color.length < 4) {
      return '#ebeef5'
    }
    return this.convertHexToRgbaColor(this.color)
  }

  /**
   * 转换hex颜色值为rgba颜色值
   */
  convertHexToRgbaColor(color, alpha = 0.2) {
    if (color.length === 4) {
      // 四位颜色值扩充为六位
      var newColor = '#'
      for (var i = 1; i < 4; i += 1) {
        newColor += color.slice(i, i + 1).concat(color.slice(i, i + 1))
      }
      color = newColor
    }
    //处理六位的颜色值
    var colorArr = []
    for (var i = 1; i < 7; i += 2) {
      colorArr.push(parseInt('0x' + color.slice(i, i + 2)))
    }
    return `rgba(${colorArr.join(',')}, ${alpha})`
  }
}
